<template>
	<div class="main-cont">
		<br>
		<h1>RESULTADOS</h1>

		<div v-for="i in results" v-bind:data="i.votes" v-bind:key="i.name" class="result">
			<img :src="i.pic"/>
			<div class="cname">
				{{ i.name }}
			</div>
			
			<div class="meter">
				<span :style="{width: i.per+'%'}">{{ i.per.toFixed(2) + '%' }}</span>
			</div>
			<div style="align-self: center;">{{ parseInt(i.votes) + ' VOTOS'}}</div>
		</div>

	<h1>CANTIDAD DE VOTOS EMITIDOS</h1>
	<h1>924</h1>

	<h1>CANTIDAD DE VOTOS NULOS</h1>
	<h1>16</h1>
	<br>
	<h1>DIRECCION DEL CONTRATO INTELIGENTE</h1>
	<h1>
	<a href="https://ropsten.etherscan.io/address/0x178c4712ba86c1524c707c5d2fe9a33ef5cb6eec">etherscan.io</a>
	</h1>
	</div>
</template>

<script>
import Web3 from "web3";

var web3 = new Web3(new Web3.providers.HttpProvider('https://ropsten.infura.io/'));
var abi = [
	{
		"constant": true,
		"inputs": [],
		"name": "see_stats",
		"outputs": [
			{
				"name": "",
				"type": "uint256[]"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	}, 
]
var ctr = new web3.eth.Contract(abi, '0x178c4712ba86c1524c707c5d2fe9a33ef5cb6eec');

export default {
  	data () {
	    return {
			results: [
				{pic: require('./assets/amlo.png'), col: '', name: 'Andrés Manuel Lopez Obrador',		 votes: 447, per: 447 * 100 / 924},
				{pic: require('./assets/raco.png'), col: '', name: 'Ricardo Anaya Cortés',				 votes: 316, per: 316 * 100 / 924},
				{pic: require('./assets/jamk.png'), col: '', name: 'José Antonio Meade Kuribreña', 		 votes: 92,  per: 92 * 100 / 924},
				{pic: require('./assets/jarc.png'), col: '', name: 'Jaime Heliodoro Rodríguez Calderón', votes: 53,  per: 53 * 100 / 924},
			],
			total: 0,
			nulos: 0,
    	}
  	},
	methods: {
		showResults(){
			ctr.methods.see_stats().call((err, val) =>{
				console.log("RES", val);
				for(var i=0;i<this.results.length;i++){
					this.results[i].votes = val[i];
					this.results[i].per = val[i] * 100 / val[5];
				}
				this.nulos = val[4];
				this.total = val[5];
			});
		}
	},
	beforeMount(){
		this.showResults();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*MAIN CONTAINER*/
.main-cont{
	height: 100%;
	width: 80%;
	overflow: hidden;
	position: relative;
	margin: auto;
}

.result{
	display: flex;
	padding: 5px;
}
.cname{
	width:250px; 
	align-self: center;
}

img{
	width: 160px;
	border-radius: 100%;
}

.meter { 
	height: 30px;  /* Can be anything */
	width: 100%;
	position: relative;
	align-self: center;
	background: #2d598b;
	border-radius: 5px;
	padding: 5px;
	box-shadow: inset 0 -1px 1px rgba(255,255,255,0.3);
}

.meter > span {
  display: block;
  height: 100%;
  background-color: #cc1999;
  box-shadow: 
    inset 0 2px 9px  rgba(255,255,255,0.3),
    inset 0 -2px 6px rgba(0,0,0,0.4);
  position: relative;
  overflow: hidden;
}

@media screen and (min-width: 960px) and (max-width: 1280px){

}

@media screen and (min-width: 480px) and (max-width: 960px){
.meter{
	height: 20px;
}
img{
	width: 96px;
}
.cname{
	width: 480px;
}
.result{
		display: inline;
	}	
}

@media only screen and (max-width: 480px){
	.main-cont{
		width: 90%;
	}
	.meter{
		height: 20px;
	}
	img{
		width: 80px;
	}
	.cname{
		padding: 0px;
		font-size: 14px;
	}
	.result{
		display: inline;
	}	
	h1{
		font-size: 18px;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/TheTimeline.vue